import { render, staticRenderFns } from "./_file-loader.vue?vue&type=template&id=1749e920&scoped=true"
import script from "./_file-loader.vue?vue&type=script&lang=js"
export * from "./_file-loader.vue?vue&type=script&lang=js"
import style0 from "./_file-loader.vue?vue&type=style&index=0&id=1749e920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1749e920",
  null
  
)

export default component.exports